<template>
  <a v-if="type === 'list'" href="javascript:void(0);" @click="showModal()">取消</a>

  <a-button v-else type="primary" @click="showModal()">取消</a-button>

  <a-modal :confirmLoading="loading" :centered="true" v-model:visible="visible" @ok="handleOk()">
    <template #title>
      <h4 class="flow-model-title">取消工单</h4>
    </template>
    <a-form layout="vertical">
      <a-form-item label="取消原因">
        <a-textarea
          v-model:value="formRef.remark"
          show-count
          placeholder="请输入取消原因"
          :rows="4"
          :maxlength="200"
        >
        </a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { Modal, message } from "ant-design-vue";
import { PropType, computed, defineComponent, reactive, toRefs, createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { TicketAssignService, TicketAssignReq } from "./service";
import { useRouter } from "vue-router";
export default defineComponent({
  isGlobal: true,
  name: "TicketCancelBtn",
  props: {
    type: {
      type: String,
      default: "list",
    },
    record: {
      type: Object as PropType<any>,
    },
    operationType: {
      //对应id key值
      type: Number,
      default: 0, //操作类型：0-派单 1-转单
    },
    afterFn: {
      type: Function,
      default: () => {},
    },
    ticketType:{
      type: String,
      default: "bx",
    }
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const state = reactive(<
      {
        loading: boolean;
        visible: boolean;
      }
    >{
      loading: false,
      visible: false,
    });
    const formRef = reactive(new TicketAssignReq());
    const router = useRouter();
    const { run: runTicketAssign, loading: submitLoading = false } =
      TicketAssignService.useTicketAssignApi();
    const showModal = async () => {
      // state.approvalContent = "";

      state.visible = true;
    };
    const handleOk = async () => {
      if(formRef.remark==''){
        message.warn('取消原因不可为空')
        return
      }
      await runTicketAssign(props.record.id, formRef,props.ticketType);
      emit("refresh");
    };

    return {
      ...toRefs(state),
      showModal,
      handleOk,
      formRef,
    };
  },
});
</script>
<style scoped>
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
</style>
